import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { slugs } from '../../Constant/slugs';
import store from '../../redux/store';
import NotFound from '../NotFound';
import FirstScreenExam from './FirstScreen';
import { useHistory } from 'react-router-dom';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { AdsGETApiAuth, AdsGETApiWithToken } from '../../Constant/api';

export default function StartTabExam(props) {
  const dispatch = useDispatch()
  const location = useLocation()
  const [ExamData, setAllExamList] = React.useState({});
  const [ExamFetch, setExamFetch] = React.useState(false);
  const [NotFoundData, setNotFound] = React.useState(false)
  const [reload, setReload] = React.useState(false)
  const [choose, setChoose] = React.useState(0)
  const [AnswerArray, setAnswerArray] = React.useState([]);
  const [ResultData, setResultData] = React.useState({ meta: { exam_date_results: "" } });
  const token = localStorage.getItem('teacher_token');
  const history = useHistory()

  const fetchExam = (slug) => {
    setExamFetch(false)
    setReload(true)
    setNotFound(true)
    const id = store.getState().LoginState.userID

    AdsGETApiAuth({ slug: slug }, slugs.db_slug_paid_exam)
      .then((res) => {
        if (res.data.length == 1) {
          if (res.data[0].meta.exam_question_block_student != undefined) {
            setAllExamList(res.data[0])
            setExamFetch(true)
            console.log("asdsad")
            setNotFound(false)
          }
          else {
            console.log("asdsad")
            setExamFetch(true)
            setNotFound(true)
          }
        }
        else {
          setExamFetch(true)
          console.log("asdsad")
          setNotFound(true)
        }
        setReload(false)
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data)
        history.pushState(slugs.classroom)
      })

  }
  const [finishStatus, setfinishStatus] = React.useState(false);
  const handle = useFullScreenHandle();
  const LoginState = useSelector((state) => state.LoginState);

  useEffect(() => {
    var slug = location.pathname.slice(slugs.start_exam.length + 1);
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    }
    else
      handle.enter()

    AdsGETApiAuth({
      status: "any",
      "filter[meta_query][1][key]": "user_id",
      "filter[meta_query][1][value][0]": LoginState.userID,
      "filter[meta_query][1][compare]": "=",
      _fields: "meta"
    }, "user_data")
      .then((response) => {
        if (response.data[0].meta.user_featured_exam_slug !== "")
          fetchExam(response.data[0].meta.user_featured_exam_slug)
        else{
          setExamFetch(true)
          setNotFound(true)
        }
      })

  }, [])

  return (
    <div>
      <FullScreen handle={handle}>
        <div style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
          <div>
            {/* <div className="row">
            <div className="col-sm-2 col-1"></div>
            <div className="col-sm-8 col-10 form-view m-3"> */}
            <div className="form-view-2 m-3">
              {ExamFetch &&
                <>
                  {NotFoundData ?
                    <NotFound /> :
                    <>
                      <FirstScreenExam
                        ExamData={ExamData}
                        setReload={setReload}
                        choose={choose}
                        setChoose={setChoose}
                        AnswerArray={AnswerArray}
                        setAnswerArray={setAnswerArray}
                        ResultData={ResultData} setResultData={setResultData}
                      />
                    </>
                  }
                </>
              }
            </div>
            {/* </div> */}
          </div>
          {reload &&
            <div className="modal" style={{ padding: "50vw" }}>
              <div className="dot-pulse"></div>
            </div>
          }
        </div>
      </FullScreen>
    </div>
  )
}